module.exports = __webpack_public_path__ + "static/media/bt_top_literally_report_normal.bfdf7230.png";